<template>
  <div>

    <b-jumbotron fluid style="background-color: #ffe066">
      <template v-slot:header>
        <h1>Hash password</h1>
      </template>
      <template v-slot:lead>
        Por René Gutiérrez Franco
        <div style="font-size: 10px">Enero-2025</div>
      </template>
    </b-jumbotron>

    <b-container>
      <label for="contrasena_maestra">Contraseña maestra:</label>
      <b-badge style="margin-left: 8px" variant="dark">{{crc_contrasena_maestra}}</b-badge>
      <b-form-input v-model="contrasena_maestra" :type="tipo_input_contrasena_maestra" ref="contrasena_maestra" placeholder="Contraseña maestra" :state="esContrasenaValida" autocomplete='off' @keyup.enter="$refs.asunto.focus();" @keyup="temporizadorBorrado"></b-form-input>
      <b-form-checkbox v-model="mostrar_contrasena_maestra">
        Mostrar contraseña
      </b-form-checkbox>

      <label style="margin-top: 25px" for="nombre">Sujeto / Asunto:</label>
      <b-form-input v-model="nombre" ref="asunto" placeholder="Sujeto / Asunto" :state="esSujetoAsuntoValido" autocomplete='off' @keyup.enter="obtenerContrasenas"></b-form-input>

      <b-button style="margin-top: 15px" variant="primary" :disabled="!formularioValidado" ref="boton" @click="obtenerContrasenas">Obtener contraseñas</b-button>
    </b-container>

    <b-container v-show="visualizar_contrasenas" style="margin-top: 25px">
      Contraseñas para '<span class="font-weight-bold">{{nombre}}</span>':
      <b-container style="margin-top: 8px">
        <b-row>
          <b-col>Alta seguridad (12):</b-col>
          <b-col><caja-contrasena :valor="contrasena_AS12"></caja-contrasena></b-col>
        </b-row>
        <b-row>
          <b-col>Alfanumerica (10):</b-col>
          <b-col><caja-contrasena :valor="contrasena_AN10" ref="contrasena_AN10"></caja-contrasena></b-col>
        </b-row>
        <b-row>
          <b-col>Alfanumerica (8):</b-col>
          <b-col><caja-contrasena :valor="contrasena_AN8"></caja-contrasena></b-col>
        </b-row>
        <b-row>
          <b-col>Alfanumerica (6):</b-col>
          <b-col><caja-contrasena :valor="contrasena_AN6"></caja-contrasena></b-col>
        </b-row>
        <b-row>
          <b-col>Numérica (6):</b-col>
          <b-col><caja-contrasena :valor="contrasena_N6"></caja-contrasena></b-col>
        </b-row>
        <b-row>
          <b-col>PIN (4):</b-col>
          <b-col><caja-contrasena :valor="contrasena_N4"></caja-contrasena></b-col>
        </b-row>
      </b-container>
    </b-container>

  </div>
</template>

<script>
import { funciones } from "@/funciones";
import CajaContrasena from "@/components/CajaContrasena";

export default {
  name: "App",
  components: {
    CajaContrasena
  },
  data: () => ({
    mostrar_contrasena_maestra: false,
    tipo_input_contrasena_maestra: "password",
    contrasena_maestra: "",
    nombre: "",
    crc_contrasena_maestra: "--",
    esContrasenaValida: null,
    esSujetoAsuntoValido: null,
    visualizar_contrasenas: false,
    contrasena_AS12: "",
    contrasena_AN10: "",
    contrasena_AN8: "",
    contrasena_AN6: "",
    contrasena_N6: "",
    contrasena_N4: "",
    manejadorTemporizadorBorrado: null
  }),
  watch: {
    mostrar_contrasena_maestra: function(val) {
      if (val) this.tipo_input_contrasena_maestra = "text";
      else this.tipo_input_contrasena_maestra = "password";
    },
    contrasena_maestra: function(val) {
      var crc = funciones.SHA1(val);
      this.crc_contrasena_maestra = crc.substr(0, 2).toUpperCase();

      if (this.contrasena_maestra.length == 0)
        this.esContrasenaValida = false;
      else
        this.esContrasenaValida = null;
    },
    nombre: function () {
      if (this.nombre.length == 0)
        this.esSujetoAsuntoValido = false;
      else
        this.esSujetoAsuntoValido = null;
    }
  },
  computed: {
    formularioValidado: function() {
      return (this.contrasena_maestra.length > 0) && (this.nombre.length > 0);
    }
  },
  methods: {
    obtenerContrasenas() {
      if (!this.formularioValidado)
        return;

      var sal = this.contrasena_maestra.trim();
      var nombre = this.nombre.trim().toLowerCase();

      if (nombre.search(/@/) < 0) {
        nombre = nombre.replace(/^http:\/\//im, "");
        nombre = nombre.replace(/^www\./im, "");
        nombre = nombre.replace(/^mail\./im, "");
        while (nombre.search(/\./) > 0) {
          nombre = nombre.replace(/\.\w+$/im, "");
        }
      }

      this.nombre = nombre;

      this.contrasena_AS12 = funciones.CalcularContrasena(sal, nombre, 10, false, true);
      this.contrasena_AN10 = funciones.CalcularContrasena(sal, nombre, 10, false, false);
      this.contrasena_AN8 = funciones.CalcularContrasena(sal, nombre, 8, false, false);
      this.contrasena_AN6 = funciones.CalcularContrasena(sal, nombre, 6, false, false);

      var contrasena_numerica = funciones.CalcularContrasena(sal, nombre, 6, true, false);
      this.contrasena_N6 = contrasena_numerica;
      this.contrasena_N4 = contrasena_numerica.substr(0, 4);

      this.visualizar_contrasenas = true;

      this.$nextTick (() => {
        this.$refs.contrasena_AN10.$refs.valor.click();
        this.$refs.asunto.focus();
      });
    },
    temporizadorBorrado () {
      if (this.manejadorTemporizadorBorrado)
        clearTimeout (this.manejadorTemporizadorBorrado);

      this.manejadorTemporizadorBorrado = setTimeout (() => {
        this.contrasena_maestra = '';
        this.contrasena_AS12 = '';
        this.contrasena_AN10 = '';
        this.contrasena_AN8 = '';
        this.contrasena_AN6 = '';
        this.contrasena_N6 = '';
        this.contrasena_N4 = '';

        this.visualizar_contrasenas = false;
      }, 1000 * 60 * 5);
    }
  },
  mounted () {
    this.$refs.contrasena_maestra.focus();
  }
};
</script>


<style>
html {
    overflow-y: auto;
}
body {
  background-color: #fcfcec;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.jumbotron {
  max-height: 190px;
}
input {
  font-family: monospace, courier new;
}
.col {
  border: 1px solid;
}
</style>